export enum SectionType {
    FIXED_PERCENTAGE = 'fixed_percentage',
    TIME_GATED_PERCENTAGE = 'time_gated_percentage',
    FIXED_COINS = 'fixed_coins',
    WIN_NOTHING = 'win_nothing'
}
